// Copyright (c) 2016 Deere & Company

import './user-settings.scss';
import PropTypes from 'prop-types';
import React from 'react';
import RouteMapping from '../../../../configmodules/routing/routeMapping';
import UserSettingsNavigationList from './user-settings-navigation-list';
import { withRouter } from 'react-router-dom';

const UserSettings = ({ childRoutes }) => (
    <section className="user-settings">
        <div className="user-settings-navigation">
            <UserSettingsNavigationList routes={childRoutes} />
        </div>
        <div className="user-settings-panel">
            <RouteMapping routes={childRoutes} />
        </div>
    </section>
);

UserSettings.displayName = 'UserDealerMappedResponse';
UserSettings.propTypes = {
    childRoutes: PropTypes.object,
};

export default withRouter(UserSettings);
